import React from 'react';
import PropTypes from 'prop-types';
import { keyCodes } from '../../../constants';
import IconButton from '../../icon-button';

const ActionGroup = ({
  editLabel = '',
  deleteLabel = '',
  onEditClick = null,
  onDeleteClick = null,
}) => {
  const isEditIconButtonEnabled = !!onEditClick;
  const isDeleteIconButtonEnabled = !!onDeleteClick;

  if (!isEditIconButtonEnabled && !isDeleteIconButtonEnabled) return null;

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEditClick();
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDeleteClick();
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.stopPropagation();
    }
  };

  return (
    <div className="ws-ui-preset-container__action-group" onKeyDown={handleKeyDown}>
      {isEditIconButtonEnabled && (
        <IconButton
          glyph="settings"
          appearance="accent"
          size="medium"
          label={editLabel}
          onClick={handleEditClick}
        />
      )}
      {isDeleteIconButtonEnabled && (
        <IconButton
          glyph="trash"
          appearance="accent"
          size="medium"
          label={deleteLabel}
          onClick={handleDeleteClick}
        />
      )}
    </div>
  );
};

ActionGroup.propTypes = {
  editLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default ActionGroup;
